import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_OFFER_ADJUSTMENT } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * CL-NEG-01 Task 11 §D — requirement 3's second row: the negotiated reduction.
 *
 * `line-item/offer-adjustment` was registered in `LINE_ITEMS` (Task 10, `types.js`) purely so
 * `LineItemUnknownItemsMaybe` stopped rendering it under a code-derived label; nothing has
 * rendered it since. This is that renderer, same shape as `LineItemPickupFeeMaybe`: find the
 * non-reversal line by code, show its `lineTotal` (the charge is the truth, not a value
 * re-derived from `protectedData.negotiation`), render nothing when absent — a BIN order has no
 * such line at all (offerLineItems.js omits it outright when the negotiated total equals list
 * price, so a seller-initiated, discount-only offer never shows a zero-amount row either).
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems
 * @param {Object} props.intl
 * @returns {JSX.Element|null}
 */
const LineItemOfferAdjustmentMaybe = props => {
  const { lineItems, intl } = props;

  const adjustmentLine = (lineItems || []).find(
    li => li.code === LINE_ITEM_OFFER_ADJUSTMENT && !li.reversal
  );

  return adjustmentLine ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.offerAdjustment" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, adjustmentLine.lineTotal)}</span>
    </div>
  ) : null;
};

export default LineItemOfferAdjustmentMaybe;
